<template>
  <div class="try-modal">
    <Modal
      v-model="isShow"
      class="tryModalBox"
      width="400px"
      @on-visible-change="resetModal"
      class-name="vertical-center-modal"
    >
      <span slot="header">{{ $t("query.result.rate.try") }}</span>

      <Form
        ref="form"
        :model="form"
        :rules="ruleForm"
        @submit.native.prevent
        class="models"
      >
        <FormItem prop="value" label="进口CIF">
          <i class="cal"></i>
          <Input
            type="text"
            v-model.trim="form.value"
            clearable
            autofocus
            @on-enter="ok"
            :placeholder="$t('query.result.rate.tryPlaceholder')"
          />
          <Select v-model="form.currency" placeholder="请选择">
            <Option value="人民币">人民币</Option>
            <Option value="美元">美元</Option>
          </Select>
        </FormItem>
        <!-- <Form-item label="选择器">
          <Select v-model="form.select" placeholder="请选择">
            <Option value="beijing">北京市</Option>
            <Option value="shanghai">上海市</Option>
            <Option value="shenzhen">深圳市</Option>
          </Select>
        </Form-item> -->
      </Form>

      <div slot="footer">
        <!--<Button type="ghost" class="cancel" @click="isShow = false">{{$t('btn.cancel')}}</Button>-->
        <Button type="primary" class="ok" @click="ok">{{
          $t("btn.confirm")
        }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "RateTryCalModal",
  props: ["amount"],
  data() {
    const isAmount = (rule, value, callback) => {
      value = this._.trim(`${value}`);
      if (!value) {
        return callback(new Error(this.$t("query.result.rate.tryPlaceholder")));
      } else if (!this.$options.filters.isPrice(value)) {
        return callback(
          new Error(this.$t("query.result.rate.tryCorrectGoodsValue"))
        );
      } else {
        value = parseFloat(value);
        if (this._.isNaN(value)) {
          return callback(
            new Error(this.$t("query.result.rate.tryPlaceholder"))
          );
        } else if (!value || value <= 0) {
          return callback(
            new Error(this.$t("query.result.rate.tryCorrectGoodsValue"))
          );
        } else if (!this._.isNumber(value)) {
          return callback(
            new Error(this.$t("query.result.rate.tryCorrectGoodsValue"))
          );
        } else {
          callback();
        }
      }
    };
    return {
      isShow: false,
      form: {
        value: this.amount || "",
        currency: "人民币"
      },
      ruleForm: {
        value: [
          // { required: true, message: this.$t('query.result.rate.tryPlaceholder'), trigger: 'blur' },
          // { type: 'number', min: 6, message: this.$t('query.result.rate.tryCorrectGoodsValue'), trigger: 'blur' }
          { validator: isAmount, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    ok() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // this.$Message.success({content: 'Success!', closable: true})
          this.isShow = false;

          this.$emit("inputAmount", this.form);
        } else {
          // this.$Message.error({content: 'Fail!', closable: true})
        }
      });
    },
    resetModal() {
      // if (!this.isShow) {
      //   this.$refs['form'].resetFields()
      // }
    }
  }
};
</script>
<style scoped>
@media print, screen and (min-width: 1366px) {
  .tryModalBox .vertical-center-modal,
  .tryModalBox .ivu-modal {
    width: 380px !important;
  }
}
@media print, screen and (max-width: 1365px) {
  .tryModalBox .vertical-center-modal,
  .tryModalBox .ivu-modal {
    width: 400px !important;
  }
}
.tryModalBox .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  /*width: 320px !important;*/
  margin: 0 auto;
  margin-top: -120px;
}
/*.tryModalBox .ivu-modal{*/
/*width: 320px !important;*/
/*}*/
.tryModalBox .vertical-center-modal .ivu-modal {
  top: 0;
}
.tryModalBox .ivu-modal-content {
  border: 0.5px solid #d8d8d8;
  border-radius: 3px;
  padding: 0 20px;
}
.tryModalBox .ivu-modal-header {
  padding: 18px 16px 18px 2px;
  border-bottom: 0.5px solid #d8d8d8;
  /*font-size: 12px;*/
  font-size: 15px;
  color: #333;
  /*font-weight: bold;*/
}
.tryModalBox .ivu-modal-close {
  top: 13px;
  right: 20px;
}
.accountModalBox .ivu-modal-close:hover {
  text-decoration: none;
  box-shadow: none;
}
.tryModalBox .ivu-modal-close .ivu-icon-ios-close-empty {
  /*font-size: 30px;*/
  width: 12px;
  height: 12px;
  background: url("~@/assets/images/icons/close.png") 0 0 no-repeat transparent;
  background-size: 12px;
}
.tryModalBox .ivu-modal-close .ivu-icon-ios-close-empty:before {
  content: none;
}
.tryModalBox .ivu-modal-body {
  padding: 20px 5px 0;
}
.tryModalBox i.cal {
  background: url("~@/assets/images/icons/search/cal.png") 0 0 no-repeat
    transparent;
  width: 11px;
  height: 10px;
  background-size: auto 10px;
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 9px;
  transform: translateY(-50%);
  margin-top: 0.5px;
}
.tryModalBox .ivu-input {
  border: 0.5px solid #dbdbdb;
  padding-left: 22px;
  border-radius: 2px;
  /*font-size: 12px;*/
  font-size: 14px;
}
.tryModalBox .ivu-form-item-error {
  margin-bottom: 30px;
}
.tryModalBox .ivu-form-item-error-tip {
  /*font-size: 11px;*/
  font-size: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.tryModalBox .ivu-input:focus {
  border-color: #1f8afd;
}
/*.tryModalBox form .ivu-form-item{*/
/*margin-bottom: 0;*/
/*}*/
.tryModalBox .ivu-modal-footer {
  /*border-top: 0.5px solid #D8D8D8;*/
  border-top: 0 none;
  padding-right: 5px;
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 30px;
}
.tryModalBox .ivu-btn {
  padding: 6px 20px;
  border-radius: 2px;
}
.tryModalBox .ivu-btn-primary {
  /*background-color: #1F8AFD;*/
  /*border-color: #1F8AFD;*/
  /*background-image: linear-gradient(90deg, #0F7EF3 0%, #27BEFE 100%);*/
  /* background-image: linear-gradient(-90deg, #0F7EF3 0%, #27BEFE 100%); */
  border-radius: 3px;
  background-color: #0470e3;
  width: 100%;
  border: 0 none;
}
.tryModalBox .ivu-icon {
  cursor: pointer;
}
.tryModalBox .ivu-input::-webkit-input-placeholder {
  /*font-size: 10px;*/
  font-size: 12px;
  position: relative;
  top: -1px;
}
.tryModalBox .ivu-input:-moz-placeholder {
  /*font-size: 10px;*/
  font-size: 15px;
  position: relative;
  top: -1px;
}
.tryModalBox .ivu-input::-moz-placeholder {
  /*font-size: 10px;*/
  font-size: 15px;
  position: relative;
  top: -1px;
}
.tryModalBox .ivu-input:-ms-input-placeholder {
  /*font-size: 10px;*/
  font-size: 15px;
  position: relative;
  top: -1px;
}
.models >>> .ivu-input {
  /*font-size: 10px;*/
  font-size: 15px;
  text-indent: 1em;
}
.models .ivu-btn {
  font-size: 15px;
}
.models >>> .ivu-form-item {
  display: flex;
}

.models >>> .ivu-form-item-label {
  width: 70px;
  font-size: 15px;
}
.models >>> .ivu-input-wrapper {
  width: 160px;
}
.models >>> .ivu-select {
  width: 100px;
}
.models
  >>> .ivu-select-single
  .ivu-select-selection
  .ivu-select-selected-value {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/query/RateTryCalModal.vue